import styled from 'styled-components';


export const LoginContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  background-image: url('/rocksafety.jpg');
  background-size: cover; /* Para que la imagen cubra toda la pantalla */
  background-position: center; /* Centra la imagen */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
`;

export const LoginBox = styled.div`
  background-color: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
`;

export const LoginTitle = styled.h1`
  margin-bottom: 20px;
  font-size: 24px;
  color: #333333;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const InputField = styled.input`
  padding: 12px 15px;
  margin-bottom: 15px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 5px;
  outline: none;
  &:focus {
    border-color: #0078d4;
    box-shadow: 0 0 5px rgba(0, 120, 212, 0.5);
  }
`;

export const RememberMeContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const RememberMeCheckbox = styled.input`
  margin-right: 10px;
`;

export const RememberMeLabel = styled.label`
  font-size: 14px;
  color: #555555;
`;

export const LoginButton = styled.button`
  padding: 12px;
  font-size: 16px;
  color: #ffffff;
  background-color: #0078d4;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #005a9e;
  }
`;

/*export const ForgotPasswordLink = styled.a`
  display: block;
  margin-top: 15px;
  font-size: 14px;
  color: #0078d4;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;*/
